module.exports = __webpack_public_path__ + "assets/img/gw.cba55b99.png";